<template>
  <div>
    <v-flex class="pt-0">
      <h2 class="page-head"><span class="page-heading">ANSI-ANAB Accreditation</span></h2>

      <p>On Tuesday, September 19, 2017, the ANAB Certificate Accreditation Program Accreditation Committee (CAPAC)
        met and approved the recommendations of the assessors to award the Cogneti LLC accreditation under ANSI/ASTM E2659-09.</p>

      <p>By agreement, food handler certificates issued by Cogneti prior to that date are valid, unless otherwise noted.
      </p>

      <p>
        Cogneti is listed as a Food Handler Certificate Provider in the ANAB directory of accredited food-handler certificate programs.</p>
      <ul>

        <li class="li"><a target="_blank" href="//www.ansi.org/accreditation/credentialing/certificate-issuers/AllDirectoryListing.aspx?prgID=212,238&statusID=4">ALL Accredited Certificate Issuers</a></li>
        <li class="li"><a target="_blank" href="//www.ansi.org/Accreditation/credentialing/certificate-issuers/AllDirectoryListing?prgID=261&statusID=4">Arizona Food Handler Program</a></li>
        <li class="li"><a target="_blank" href="//www.ansi.org/Accreditation/credentialing/certificate-issuers/AllDirectoryListing.aspx?prgID=262&statusID=4">California Food Handler Program</a></li>

        <li class="li"><a target="_blank" href="//www.ansi.org/Accreditation/credentialing/certificate-issuers/AllDirectoryListing.aspx?prgID=263&statusID=4">Illinois Food Handler &amp; Allergens Programs</a></li>

        <li class="li"><a target="_blank" href="//www.ansi.org/Accreditation/credentialing/certificate-issuers/AllDirectoryListing.aspx?prgID=264&statusID=4">New Mexico Food Handler Program</a></li>

        <li class="li"><a target="_blank" href="//www.ansi.org/Accreditation/credentialing/certificate-issuers/AllDirectoryListing.aspx?prgID=265&statusID=4">Texas Food Handler Program</a></li>

        <li class="li"><a target="_blank" href="//www.ansi.org/Accreditation/credentialing/certificate-issuers/AllDirectoryListing.aspx?prgID=266&statusID=4">West Virginia Food Handler Program</a></li>

        <!--<li class="li"><a href="AllDirectoryListing.aspx?prgID=228,238&statusID=4">California Food Handler Certificate Program</a></li>
        <li class="li"><a href="AllDirectoryListing.aspx?prgID=237,238&statusID=4">Food Handler Training Certificate Program</a></li>-->
      </ul>

    </v-flex>
  </div>
</template>

<script>
export default {
  name: 'CertificateProgramContent'
}
</script>



// WEBPACK FOOTER //
// src/components/views/guest/AnsiAccreditation/Program68.vue